import { render } from "./post-smtp-pro-features.vue?vue&type=template&id=64cc4817&scoped=true"
import script from "./post-smtp-pro-features.vue?vue&type=script&lang=js"
export * from "./post-smtp-pro-features.vue?vue&type=script&lang=js"

import "./post-smtp-pro-features.vue?vue&type=style&index=0&id=64cc4817&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64cc4817"],['__file',"src/components/post-smtp-pro-features.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "64cc4817"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('64cc4817', __exports__)) {
    api.reload('64cc4817', __exports__)
  }
  
  module.hot.accept("./post-smtp-pro-features.vue?vue&type=template&id=64cc4817&scoped=true", () => {
    api.rerender('64cc4817', render)
  })

}


export default __exports__